/* External dependencies */
import { Container, Div } from 'atomize';
import React from 'react';

/* Local dependencies */
import MeducationTitle from '../meducation-title';

interface MeducationBlockProps {
  blockBg: string;
  blockPadding: any;
  blockTitle: string;
  blockTitleMargin?: any;
  children?: JSX.Element;
  blockTitleColor?: string;
  blockTitleTextAlign?: string;
  blockTitleTextSizeXS?: string;
  blockTitleTextSizeMD?: string;
}

export default function MeducationBlock({
  blockBg,
  blockPadding,
  blockTitle,
  blockTitleMargin,
  children,
  blockTitleColor = 'bg_black',
  blockTitleTextAlign = 'left',
  blockTitleTextSizeXS = '40px',
  blockTitleTextSizeMD,
}: MeducationBlockProps) {
  return (
    <Div bg={blockBg} p={blockPadding}>
      <Container>
        <Div textAlign={blockTitleTextAlign} m={blockTitleMargin}>
          <MeducationTitle
            title={blockTitle}
            textColor={blockTitleColor}
            textSizeXS={blockTitleTextSizeXS}
            textSizeMD={blockTitleTextSizeMD}
          />
        </Div>
      </Container>
      <Div>{children}</Div>
    </Div>
  );
}
